.overlay {
  position: fixed;
  inset: 0;
  background: light-dark(rgba(15, 30, 40, 0.4), rgba(0, 0, 0, 0.6));
  backdrop-filter: blur(4px);
  z-index: 1100;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: clamp(60px, 12vh, 120px) 16px 16px;
  animation: fadeIn 120ms ease;
}

.dialog {
  width: 100%;
  max-width: 640px;
  background: light-dark(#ffffff, var(--mantine-color-dark-7));
  border: 1px solid light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-4));
  border-radius: 14px;
  box-shadow:
    0 10px 38px -10px light-dark(rgba(22, 23, 24, 0.35), rgba(0, 0, 0, 0.6)),
    0 10px 20px -15px light-dark(rgba(22, 23, 24, 0.2), rgba(0, 0, 0, 0.4));
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: min(70vh, 540px);
  animation: slideIn 160ms cubic-bezier(0.2, 0.9, 0.3, 1);
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.inputWrap {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border-bottom: 1px solid light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-4));
}

.searchIcon {
  color: var(--mantine-color-dimmed);
  flex-shrink: 0;
}

.input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 15px;
  color: inherit;
  font-family: inherit;
}
.input::placeholder {
  color: var(--mantine-color-dimmed);
}

.escBadge {
  font-size: 11px;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 4px;
  background: light-dark(var(--mantine-color-gray-1), var(--mantine-color-dark-5));
  color: var(--mantine-color-dimmed);
  border: 1px solid light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-4));
  font-family: ui-monospace, SFMono-Regular, monospace;
}

.list {
  flex: 1;
  overflow-y: auto;
  padding: 6px;
  scrollbar-width: thin;
}

.group {
  padding: 4px 0 8px;
}

.groupHeading {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--mantine-color-dimmed);
  padding: 8px 12px 4px;
}

.item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: inherit;
  transition: background 80ms ease;
  user-select: none;
}

.item[data-selected="true"] {
  background: light-dark(var(--mantine-color-laut-0), rgba(14, 124, 123, 0.18));
  color: light-dark(var(--mantine-color-laut-9), var(--mantine-color-laut-2));
}

.itemIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 7px;
  background: light-dark(var(--mantine-color-gray-1), var(--mantine-color-dark-5));
  color: light-dark(var(--mantine-color-laut-7), var(--mantine-color-laut-3));
  flex-shrink: 0;
}

.item[data-selected="true"] .itemIcon {
  background: light-dark(var(--mantine-color-laut-1), rgba(14, 124, 123, 0.3));
  color: light-dark(var(--mantine-color-laut-7), var(--mantine-color-laut-2));
}

.itemLabel {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.itemTitle {
  font-weight: 500;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.itemSub {
  font-size: 12px;
  color: var(--mantine-color-dimmed);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.empty {
  padding: 28px 16px;
  text-align: center;
}
.emptyTitle {
  font-size: 14px;
  font-weight: 500;
  color: var(--mantine-color-dimmed);
  margin-bottom: 4px;
}
.emptyHint {
  font-size: 12px;
  color: var(--mantine-color-dimmed);
}

.footer {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 14px;
  border-top: 1px solid light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-4));
  font-size: 11px;
  color: var(--mantine-color-dimmed);
}

.kbd {
  font-family: ui-monospace, SFMono-Regular, monospace;
  font-size: 10px;
  font-weight: 500;
  padding: 2px 5px;
  border-radius: 3px;
  background: light-dark(var(--mantine-color-gray-1), var(--mantine-color-dark-5));
  border: 1px solid light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-4));
  margin-right: 4px;
  display: inline-block;
  min-width: 18px;
  text-align: center;
}

.footerSpacer {
  flex: 1;
}

/* Sidebar trigger button */
.triggerButton {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 7px 10px;
  margin: 0 0 8px;
  border: 1px solid light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-4));
  border-radius: 8px;
  background: light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-7));
  color: var(--mantine-color-dimmed);
  font-size: 13px;
  cursor: pointer;
  transition:
    background 120ms ease,
    border-color 120ms ease;
}

.triggerButton:hover {
  background: light-dark(var(--mantine-color-gray-1), var(--mantine-color-dark-6));
  border-color: light-dark(var(--mantine-color-gray-4), var(--mantine-color-dark-3));
}

.triggerButtonCollapsed {
  composes: triggerButton;
  width: 36px;
  height: 36px;
  padding: 0;
  justify-content: center;
}

.triggerLabel {
  flex: 1;
  text-align: left;
}
